module.exports = __webpack_public_path__ + "f8d89640579081e3.svg";